import React, { Component } from "react";
import * as auth from "../../store/ducks/auth.duck";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { LayoutSplashScreen } from "../../../_metronic";

class Logout extends Component {
  componentDidMount() {
    this.props.logout();
  }

  render() {
    const { hasAuthToken } = this.props;

    window.localStorage.removeItem("brcom:destiny-location");
    window.localStorage.removeItem("brcom:destiny-location-resp");
    window.localStorage.removeItem("brcom:send-location-resp");
    window.localStorage.removeItem("brcom:send-location");

    return hasAuthToken ? <LayoutSplashScreen /> : <Redirect to="/auth" />;
  }
}

export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.authData) }),
  auth.actions
)(Logout);
